import { render, staticRenderFns } from "./fenxiao_order.vue?vue&type=template&id=79248da8&scoped=true"
import script from "./fenxiao_order.vue?vue&type=script&lang=js"
export * from "./fenxiao_order.vue?vue&type=script&lang=js"
import style0 from "./fenxiao_order.vue?vue&type=style&index=0&id=79248da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79248da8",
  null
  
)

export default component.exports